<template>
  <div id="app">
   <header class="topsite">
    <div class="content top" style="display: block;">
      <p class="topsite_title">Регистрация</p>
	    <div id="nav">
	      <router-link to="/">Главная</router-link> |
	      <router-link to="/login">Войти</router-link>
	      <span v-if="isLoggedIn"> | <router-link to="/secure">Скрытая страница</router-link></span>
	      <span v-if="isLoggedIn"> | <a @click="logout">Выйти</a></span>
	    </div>

        <!-- RD Navbar -->
        <div class="rd-navbar-wrap" style="display: none;">
          <nav data-layout="rd-navbar-fixed" data-sm-layout="rd-navbar-static" data-md-device-layout="rd-navbar-fixed"
            data-lg-layout="rd-navbar-static" data-lg-device-layout="rd-navbar-static" data-sm-stick-up-offset="40px"
            data-lg-stick-up-offset="50px" class="rd-navbar">
            <div class="rd-navbar-inner">
              <!-- RD Navbar Panel -->
              <div class="rd-navbar-panel">
                <div class="rd-navbar-panel-canvas"></div>
        
                <!-- RD Navbar Toggle -->
                <button class="rd-navbar-toggle" data-rd-navbar-toggle=".rd-navbar-nav-wrap"><span></span></button>
                <!-- END RD Navbar Toggle -->
              </div>
              <!-- END RD Navbar Panel -->
            </div>
            <div class="rd-navbar-outer">
              <div class="rd-navbar-inner">
        
        
                <div class="rd-navbar-subpanel">
                  <div class="rd-navbar-nav-wrap">
                    <!-- RD Navbar Nav -->
                    <ul class="rd-navbar-nav">
                      <li class="active">
                        <a href="#home">Инструкция</a>
                      </li>
                      <li>
                        <a href="#about">Лицензия</a>
                      </li>
                      <li>
                        <a href="/index_login.html">Войти</a>
                      </li>
                    </ul>
                    <!-- END RD Navbar Nav -->
                  </div>
        
                </div>
              </div>
            </div>
          </nav>
        </div>
        <!-- END RD Navbar -->



    </div>
    <img class="logo" src="/img/icon.png" />
  </header>



    <router-view/>
  </div>
</template>
<script>
  export default {
    computed : {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
    },
    methods: {
      logout: function () {
        this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
      }
    },
    created: function () {
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch("logout")
          }
          throw err;
        });
      });
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  float: right;
}

#nav a {
  font-weight: bold;
  color: #FFF;
  cursor: pointer;
}

#nav a:hover {
  text-decoration: underline;
}

#nav a.router-link-exact-active {
  color: #FFF;
  font-weight: bold;
}
</style>
